import axiosInstance from "@/api/axiosInstance";
import { CreateHeroItemRequest, HeroItem } from "../types";

/**
 * Create a new hero item
 * POST /api/admin/hero-items
 */
export async function createHeroItem(
  data: CreateHeroItemRequest,
): Promise<HeroItem> {
  const response = await axiosInstance.post<HeroItem>(
    "/api/admin/hero-items",
    data,
  );
  return response.data;
}
